import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatbotService } from './services/chatbot.service';

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [
    ChatbotService
  ],
})
export class HelpersModule {}
